import _ from 'lodash';
import classnames from 'classnames';

function getClassNames(state, staticClasses) {

	let currentActions = [];

	// Get the list of base classes from state.universalActions key names.
	const universalActions = _.chain(state.universalActions)
		.map((value, key) => (value ? key : undefined))
		.filter(action => !!action)
		.value();

	if (state.universalActions.isBeingPet) {
		// Get the values of each pet action that doesn't have null actions.
		currentActions = _.filter(state.actions.pet, action => !!action);

	} else if (state.actions.idle.sleep) {
		// It's sleeping so only return the sleep action.
		currentActions = state.actions.idle.sleep;

	} else {
		// Get the values of each pet action that doesn't have null actions.
		currentActions = _.filter(state.actions.idle, action => !!action);
	}

	const classes = classnames(
		staticClasses,
		universalActions,
		currentActions,
	);

	return classes;
}

module.exports = getClassNames;



// WEBPACK FOOTER //
// ./src/utils/getClassNames.js